var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThinborder1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1038_6101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M736.572 527.32H22.7399C22.3266 527.32 21.9625 527.054 21.8248 526.661C18.4989 516.732 10.5877 508.82 0.65927 505.494C0.265676 505.366 0 504.992 0 504.579V22.7414C0 22.3281 0.265676 21.964 0.65927 21.8262C10.5877 18.5001 18.4989 10.5884 21.8248 0.659313C21.9527 0.265693 22.3266 0 22.7399 0H736.572C736.985 0 737.349 0.265693 737.487 0.659313C740.813 10.5884 748.724 18.5001 758.653 21.8262C759.046 21.9542 759.312 22.3281 759.312 22.7414V504.579C759.312 504.992 759.046 505.356 758.653 505.494C748.724 508.82 740.813 516.732 737.487 526.661C737.359 527.054 736.985 527.32 736.572 527.32ZM23.4188 525.401H735.883C739.445 515.423 747.406 507.462 757.373 503.91V23.4302C747.396 19.868 739.435 11.907 735.883 1.92874H23.4188C19.8568 11.907 11.8964 19.868 1.91877 23.4302V503.9C11.8964 507.462 19.8568 515.423 23.4188 525.391V525.401Z",
    fill: "#C4944D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1038_6101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinborder1);
export default __webpack_public_path__ + "static/media/Thinborder1.f6d054378aa39f116014ca8060cb77b9.svg";
export { ForwardRef as ReactComponent };